import { DeleteTwoTone } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteResource } from '../../../redux/resources/actions';

export const DeleteResource = ({ item }) => {
    const dispatch = useDispatch();

    const deleteResource_fun = () => {
        dispatch(deleteResource(item._id));
        message.success("Deleted");
    };

    const confirm = () => {
        deleteResource_fun();
    };

    const cancel = () => {};

    return (
        <Popconfirm
            onConfirm={confirm}
            onCancel={cancel}
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
        >
            <DeleteTwoTone twoToneColor="red" key="delete" />
        </Popconfirm>
    );
};

export default DeleteResource;
